//Importaciones
import React from 'react'
import { useContext } from 'react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import MainAppContext from '../../../../MainAppContext';
import { useSelector } from 'react-redux';
import AuthVerify from '../../../../components/Templates/Site/AuthVerify';
import CalendarFilter from '../../../../components/Products/sKPI/Board/CalendarFilter';
import { Responsive, WidthProvider } from 'react-grid-layout';
import { useGetBoardStructureComponentsData2, useGetBoardStructureGeneric } from '../useOfBoard';
import { mergeStyleSets } from '@fluentui/react';
import BoardComponentInfoContent from '../ComponentManager/BoardComponentInfoContent';
import { enum__BOARD_TEMPLATE_TYPE } from '../../../../common/Dictionaries';
import { __onGetDataGridHtmlContainer } from '../../../../common/CommonFuctions';
import Loading from '../../../../components/Templates/Site/Loading';
import "../../../../../node_modules/react-grid-layout/css/styles.css";
import "../../../../../node_modules/react-resizable/css/styles.css";
import { forEach } from 'lodash-es';
import { isNullUndefined } from '../../../../common/Helpers';

function Landing(props) {
    //Helpers
    const { t } = useTranslation();
    const { token: currentAuth } = useSelector((state) => state.auth);
    const contextSite = useContext(MainAppContext);
    const ResponsiveGridLayout = WidthProvider(Responsive);
    const BoardTypeId = enum__BOARD_TEMPLATE_TYPE.LANDING;
    const hasPageElementId = false;
    
    const {
        _boardComponentInfoRecursiveValues: boardComponentInfoRecursiveValues,
        _boardComponentInfoRecursiveFilled: boardComponentInfoRecursiveFilled,
        _boardPageRedy: boardPageRedy
    } = useSelector((state) => state.boardViewComponentsScope);

    const { _boardContractFilterOfComponents: boardContractFilterOfComponents } = useSelector((state) => state.boardViewComponentsScope);

    const [boardStructureGeneric, setBoardStructureGeneric] = useState(null)
    const [structureFireGetData, setStructureFireGetData] = useState(true);

    const [messageConfig, setMessageConfig] = useState({ message : null, messageType : "error", showMessage : true });
    const [userPropsKpi, setUserPropsKpi] = useState({hasAccess : null, onlyObserver: null})
    const classNames = mergeStyleSets({
        overflow: {
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
        },
        parent: {
          selectors: { '> *:last-child': { marginTop: 10 } },
        },
    });

    const layoutConfiguration = {
        measureBeforeMount: true,
        breakpoints: { lg: 1200, md: 996, sm: 768, xs: 480, xxs: 0 },
        cols: { lg: 36, md: 30, sm: 18, xs: 12, xxs: 6 },
        rowHeight: 46,
        draggableHandle: ".dragHandle",
        margin: [10, 10, 10, 10]
    }

    useGetBoardStructureGeneric(BoardTypeId, null, boardStructureGeneric, setBoardStructureGeneric);
    useGetBoardStructureComponentsData2(boardContractFilterOfComponents, hasPageElementId, null, boardStructureGeneric, contextSite.kpiModule.boardCalendarFilterConfig, boardComponentInfoRecursiveFilled, false);

    const generateContainer = (boardStructure, container) => {
        return  <>
                    {
                        container.l_components_info.map((componentInfo, index) => {
                            return  <div key={index} className='h-100'
                            data-container-id={!isNullUndefined(componentInfo) ? componentInfo.containerId : ''}
                            data-component-id={!isNullUndefined(componentInfo) ? componentInfo.id : ''}>
                                        <BoardComponentInfoContent
                                            inputParam_HasPageElementId={hasPageElementId}
                                            inputParam_ElementId={null}
                                            inputParam_ContainerComponent={componentInfo}
                                            inputParam_BoardType={BoardTypeId}
                                            inputParam_BoardId={boardStructureGeneric.boardId}
                                            inputParam_BoardStructure={boardStructure}
                                            inputParam_Container={container}
                                        />
                                    </div>
                                    
                        })
                    }
                </>
            
    };

    let _structure = {
        html: {
            xl: [],
            lg: [],
            md: [],
            sm: [],
            xs: [],
            xxs: []
        },
        containers: []
    }

    boardStructureGeneric && boardStructureGeneric.length > 0 && boardStructureGeneric[0].l_structure[0].l_container.forEach(container => {
        let _container = __onGetDataGridHtmlContainer(container)

        if (_container.lg) {
            _structure.html.lg.push(_container.lg)
            _structure.html.md.push(_container.md ? _container.md : _container.lg)
            _structure.html.sm.push(_container.sm ? _container.sm: _container.lg)
            _structure.html.xs.push(_container.xs ? _container.xs: _container.lg)
            _structure.html.xxs.push(_container.xxs ? _container.xxs: _container.lg)
        }
        else {
            _structure.html.lg.push(_container)
        }

        _structure.containers.push(container)
    });

    //Render de componente.
    return (<>
                <div style={{display: boardPageRedy ? "block" : "none"}}>
                    <AuthVerify currentToken={currentAuth} />
                    {
                        boardStructureGeneric &&
                        <>
                            {
                                boardStructureGeneric &&
                                <CalendarFilter inputParam_BoardId={boardStructureGeneric.boardId} inputParam_ForceShowCalendar={true} />
                            }
                            {
                                boardStructureGeneric && boardComponentInfoRecursiveValues &&
                                boardStructureGeneric.map((boardStructure, indexBoardStructure) => {
                                    return <div key={indexBoardStructure}>
                                        {
                                            boardStructure.l_structure.length === 1 &&
                                            <ResponsiveGridLayout
                                                measureBeforeMount={layoutConfiguration.measureBeforeMount}
                                                breakpoints={layoutConfiguration.breakpoints}
                                                cols={layoutConfiguration.cols}
                                                rowHeight={layoutConfiguration.rowHeight}
                                                isDraggable={false}
                                                isDroppable={false}
                                                isResizable={false}
                                                margin={layoutConfiguration.margin}
                                                layouts={_structure.html}
                                            >
                                                {
                                                    _structure.html.lg.map((container, index) => (
                                                        <div key={index} data-grid={ container } className="gridItem" >
                                                            {generateContainer(boardStructure, _structure.containers[index])}
                                                        </div>
                                                    ))
                                                }
                                            </ResponsiveGridLayout>
                                        }
                                        {
                                            boardStructure.l_structure.length > 1 &&
                                            boardStructure.l_structure.map((structure, index) => {
                                                return <ResponsiveGridLayout
                                                    key={index}
                                                    //breakpoints={{ lg: 1200, xs: 480 }}
                                                    cols={ { lg: 12, xs: 6 } }
                                                    rowHeight={ structure.htmlStructure.rowHeight }
                                                    //onLayoutChange={onLayoutChange}
                                                    //onResize={onResize}
                                                    //draggableHandle={ boardMoveZones ? ".dragHandle" : '.no-drag'}
                                                    margin={[10, 10, 10, 10]}
                                                >
                                                    {
                                                        structure.l_container.map((container, index) => (
                                                            <div key={index} className="gridItem" data-grid={__onGetDataGridHtmlContainer(container)} style={{ height: `${container.h * 50}px`, width: `${container.w * 48.5}px` }}>
                                                                {generateContainer(container)}
                                                            </div>
                                                        ))
                                                    }
                                                </ResponsiveGridLayout>
                                            })
                                        }
                                    </div>
                                }) 
                            }
                        </>
                    }
                    {
                        //(hasPageElementId === null || (userPropsKpi.hasAccess === false && userPropsKpi.onlyObserver === false)) &&
                        //<div className="pt-5 mt-4">
                        //    <MessageBox  
                        //        inputParam_Message={ hasPageElementId === null ? t('data-lang-msg-invalidboard') : ((userPropsKpi.hasAccess === false && userPropsKpi.onlyObserver === false) ? t('data-lang-msg-accessdenied') : "") }
                        //        inputParam_Display={ messageConfig.showMessage }
                        //        inputParam_MessageType={ messageConfig.messageType }
                        //        inputParam_SetterMessage={ setMessageConfig }
                        //    />
                        //</div>
                    }   
                </div>
                {
                    !boardPageRedy &&
                    <div>
                        <Loading inputParam_ShowLoading={true}/>
                    </div>
                }
            </>
    );
}

export default Landing;